var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.SignIn),expression:"SignIn"}],attrs:{"justify":"center"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.users,"sort-by":"name.first","item-key":"id.value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }